<template>
  <div class='shrink-0'>
    <img
      v-if='flagPath'
      :src='flagPath'
      :alt='alt'
      class='inline-block shrink-0 rounded-full'
      :class='iconSizeClass'
    >
    <span
      v-else
      class='flex items-center justify-center rounded-full border border-gray-400 p-1.5 text-[8px] uppercase leading-none'
      :class='iconSizeClass'
    >
      {{ iso }}
    </span>
  </div>
</template>

<script lang="ts">
  import { computed, defineComponent } from 'vue'
  import countryList from '@/components/icons/flag/countryList'
  import localeList from '@/components/icons/flag/localeList'

  export default defineComponent({
    name: 'FlagIcon',
    props: {
      type: {
        type: String,
        default: 'country',
        validator: (value: string) => ['country', 'locale'].includes(value),
      },
      iso: {
        type: String,
        default: '',
      },
      alt: {
        type: String,
        default: '',
      },
      iconSizeClass: {
        type: String,
        default: 'h-4 w-4',
      },
    },
    setup(props) {
      // const flagPath = ref(null) as Ref<string | null>;
      const flagPath = computed(() => {
        if (props.type === 'country' && countryList.includes(props.iso)) {
          return `/assets/images/icons/flags/country/${props.iso}.svg`
        } else if(props.type === 'locale' && localeList.includes(props.iso)) {
          return `/assets/images/icons/flags/language/${props.iso}.svg`
        }

        return null
      })

      //    flagPath.value = getFlag();

      return {
        flagPath,
      }
    },
  })
</script>
